import {
  AfterViewInit,
  Directive,
  ElementRef,
  Input,
  Renderer2,
} from '@angular/core';
@Directive({
  standalone: true,
  selector: '[highlightStatus]',
})
export class HighlightStatusDirective implements AfterViewInit {
  @Input() status!: any;

  constructor(private readonly renderer: Renderer2, private readonly el: ElementRef) {}

  public ngAfterViewInit() {
    let className: any;
    if (this.status == 'Active') {
      className = 'active-status';
    } else if (this.status === 'Inactive') {
      className = 'inactive-status';
    } else if (this.status === 'In Progress') {
      className = 'in-progress-status';
    }
    this.renderer.addClass(this.el.nativeElement, className);
  }
}
